import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function BetrayalSection() {
  return <section className="w-full py-24 px-4 bg-[#161616] border-t border-gray-800" data-id="element-3">
      <div className="max-w-4xl mx-auto" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-5">
          <div className="text-center space-y-4" data-id="element-6">
            <div className="flex items-center justify-center gap-2 text-accent mb-4" data-id="element-7">
              <AlertTriangle className="w-6 h-6" data-id="element-8" />
              <span className="font-bold tracking-widest uppercase" data-id="element-9">
                Status Report
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-10">
              The "Laboratory Betrayal" is real.
            </h2>
          </div>

          <div className="prose prose-lg prose-invert mx-auto text-gray-300 leading-relaxed" data-id="element-11">
            <p className="text-xl" data-id="element-12">
              You’re sitting in the doctor’s office. You’ve lost 10 pounds. You
              haven't touched a donut in months. You’ve walked until your feet
              hurt. You’re convinced that{' '}
              <span className="text-white font-semibold" data-id="element-13">
                this time, the labs will reflect your sacrifice.
              </span>
            </p>

            <div className="my-10 pl-6 border-l-4 border-accent bg-gray-900/50 p-6 rounded-r-lg" data-id="element-14">
              <p className="text-xl md:text-2xl font-serif italic text-white m-0" data-id="element-15">
                "Your A1C barely moved. It’s still at 6.1. If we don’t see a
                change soon, we’re looking at medication."
              </p>
            </div>

            <p data-id="element-16">
              That feeling of injustice? That's because after 50, "eating less
              sugar" is a generic lie. Your body hasn't forgotten how to eat; it
              has forgotten how to{' '}
              <span className="text-accent font-bold" data-id="element-17">clear the pipes</span>.
            </p>
          </div>

          {/* Product Intro Transition */}
          <div className="mt-16 bg-gray-900 border border-gray-800 p-8 md:p-12 rounded-xl text-center relative overflow-hidden" data-id="element-18">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-50" data-id="element-19" />

            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-20">
              Introducing: A1C SHOCKPROOF (50+)
            </h3>

            <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-6" data-id="element-21">
              This is not a health book. It is a{' '}
              <span className="text-white font-bold border-b border-accent/50" data-id="element-22">
                Glucose Interception Manual
              </span>
              .
            </p>

            <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-23">
              While generic advice tells you to "eat more salads," we focus on
              the{' '}
              <span className="text-accent font-bold" data-id="element-24">
                3-Number Control Panel
              </span>
              —the only way to force your A1C down by managing the{' '}
              <span className="text-white font-semibold" data-id="element-25">"Float Time"</span> of
              glucose in your blood.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}